/** @format */
import { styles as linkStyles } from '@mpb-com/feather/components/atoms/link/link.styles';
import { theme as featherTheme } from '@mpb-com/feather/theme';
import { css } from 'styled-components';

import { LinkColor, LinkSize, LinkVariant } from './types';

export const thirdPartyLinkStyles = css`
    ${linkStyles({
        theme: featherTheme,
        $variant: LinkVariant.DEFAULT,
        $linkColor: LinkColor.DARK,
        $hasArrow: false,
        $size: LinkSize.INHERIT,
        disabled: false,
        $hasOutlineOnFocus: false,
        href: 'something', // link styles require a href or onClick to display the cursor as a pointer
        onClick: undefined,
        $isDisabled: false,
    })}
`;
